import { getStoredCampaignPath, getStoredCampaignSource } from "./registration";

const LEONARDO_CAMPAIGN_PATHS = ["/leonardo-nikolai", "/leonardo-nyx"];
const LEONARDO_CAMPAIGN_SOURCES = ["leonardo-nikolai", "leonardo-nyx"];

export const isLeonardoCampaign = () =>
  LEONARDO_CAMPAIGN_PATHS.includes(getStoredCampaignPath()) ||
  LEONARDO_CAMPAIGN_SOURCES.includes(getStoredCampaignSource());

export const isLeonardoFlowPath = (pathname = "", search = "") => {
  const currentPath = String(pathname);
  if (LEONARDO_CAMPAIGN_PATHS.some((path) => currentPath.startsWith(path))) return true;
  const params = new URLSearchParams(search);
  const next = params.get("next") || "";
  if (LEONARDO_CAMPAIGN_PATHS.some((path) => next.includes(path))) return true;
  if (String(pathname).startsWith("/auth/verifizieren") && isLeonardoCampaign()) return true;
  if (String(pathname).startsWith("/buchen/erfolg") && isLeonardoCampaign()) return true;
  return isLeonardoCampaign();
};
